import React from 'react';
import { Mail} from 'lucide-react'
import { FaLinkedin, FaGithub } from "react-icons/fa";
function Contact() {

    return (
        <section id='contact' className='relative mb-10 rounded-2xl py-20 bg-gradient-to-b from-[#0F0F23] via-[#1A1A2E] to-[#0F0F23] text-white'>
            <div className='absolute inset-0' />
            <div className='relative z-10 mx-auto flex w-full max-w-7xl flex-col gap-10 px-6'>
                <div className='text-center'>
                    <h2 className='text-5xl font-bold'>Contact</h2>
                    <p className='mt-3 text-lg text-purple-200/80'>Let's get in touch!</p>
                </div>

                <div className='flex justify-center gap-10 max-md:flex-col'>
                    <div className='rounded-3xl w-[1000px] max-md:w-full border border-purple-500/20 bg-black/40 p-8'>
                        <h3 className='text-2xl font-semibold text-purple-300'>Reach me directly</h3>
                        <p className='mt-4 text-base text-purple-100'>Fastest way: LinkedIn or Email. I respond quickly on weekdays.</p>
                        <ul className='mt-6 space-y-4 text-sm text-purple-100'>
                            <li className='flex items-start gap-3'>
                                <span className='text-purple-400'><Mail /></span>
                                <div>
                                    <strong className='text-purple-200'>Email</strong>
                                    <p className='text-purple-100'>ywael000@gmail.com</p>
                                </div>
                            </li>
                            <li className='flex items-start gap-3'>
                                <span className='text-purple-400'><FaLinkedin size={25}/></span>
                                <div>
                                    <strong className='text-purple-200'>LinkedIn: </strong>
                                    <a href='https://www.linkedin.com/in/youssef-elsebaey-b67343326/' target='_blank' rel='noreferrer' className='text-cyan-300 hover:text-cyan-400'>youssef-wael</a>
                                </div>
                            </li>
                            <li className='flex items-start gap-3'>
                                <span className='text-purple-400'><FaGithub size={25} /></span>
                                <div>
                                    <strong className='text-purple-200'>GitHub: </strong>
                                    <a href='https://github.com/youssef124wael' target='_blank' rel='noreferrer' className='text-cyan-300 hover:text-cyan-400'>youssef124wael</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
